import React from 'react';
import { TartaWordmark } from './TartaWordmark';
export function Footer() {
  return <footer className="bg-espresso text-cream/60 pt-24 pb-12 border-t border-cream/5" data-id="element-53">
      <div className="max-w-[1400px] mx-auto px-8 lg:px-14" data-id="element-54">
        <div className="grid sm:grid-cols-2 lg:grid-cols-12 gap-12 lg:gap-10 pb-16 border-b border-cream/10" data-id="element-55">
          <div className="lg:col-span-6 text-cream" data-id="element-56">
            <TartaWordmark height={26} strokeWidth={1.4} data-id="element-57" />
            <p className="mt-3 text-[10px] tracking-[0.4em] uppercase text-cream/50" data-id="element-58">
              A slice of heaven
            </p>
            <p className="mt-10 font-serif italic text-cream/50 text-lg max-w-sm leading-[1.5]" data-id="element-59">
              One bite closer to heaven.
            </p>
          </div>
          <div className="lg:col-span-3" data-id="element-60">
            <p className="text-[10px] tracking-[0.3em] uppercase text-caramel mb-5" data-id="element-61">
              Origin
            </p>
            <p className="text-[14px]" data-id="element-62">Magnolia, Texas</p>
            <p className="text-[14px] text-cream/40 mt-1" data-id="element-63">Coming Soon</p>
          </div>
          <div className="lg:col-span-3" data-id="element-64">
            <p className="text-[10px] tracking-[0.3em] uppercase text-caramel mb-5" data-id="element-65">
              Follow
            </p>
            <a href="https://instagram.com/tartahtx" target="_blank" rel="noreferrer" className="text-[14px] hover:text-caramel transition-colors duration-500" data-id="element-66">
              @tartahtx
            </a>
          </div>
        </div>
        <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-between text-[10px] tracking-[0.3em] uppercase text-cream/30" data-id="element-67">
          <p data-id="element-68">© {new Date().getFullYear()} TARTA</p>
          <p data-id="element-69">Crafted in Magnolia, Texas</p>
        </div>
      </div>
    </footer>;
}